<div class="signup-wrap">
  <div class="signup-wrap__inner">
    <div class="signup signup--checkout">
      <app-plan [planType]="planType" [upgrade]="true" [highlighted]="true" [selected]="true"></app-plan>
      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="signup__form">
        <div class="signup__form-inner">
          <h2 class="signup__form-title">Upgrade Your Plan</h2>
          <p class="signup__form-text">Whether you are looking to start a new line of business, invest in an innovative marketing strategy, or evaluate your financial institution’s performance, Lakehouse Analytics will give you the data you need to make effective decisions.</p>
          @if (planType != 'PeerComparisonBasic') {
          <div class="signup__field">
            <label for="subscription">Subscription</label>
            <select formControlName="subscription">
              <option value="">Please select subscription</option>
              @for (subscription of subscriptions; track subscription.id) {
              <option value="{{ subscription.id }}">
                {{ subscription.display }}
              </option>
              }
            </select>
            @if (form.controls.subscription.invalid && (form.controls.subscription.dirty || form.controls.subscription.touched)) {
            <div class="signup__error">
              @if (form.controls.subscription.errors?.['required']) {
              <div>
                Subscription is required.
              </div>
              }
            </div>
            }
          </div>
          <div class="signup__field">
            <label for="pay">Payment</label>
            <div id="card-element"></div>
            <div id="card-element-errors" role="alert" class="signup__error">{{ cardError }}</div>
          </div>
          }
          <button class="button" type="submit" [disabled]="!form.valid || submitDisabled">Signup Now</button>
        </div>
      </form>
    </div>
  </div>
</div>
